<template>
    <div v-if="backdrop">
        <div class="modal fade" :class="modal.open ? 'show' : ''" style="display: block" tabindex="-1" role="dialog"
            aria-hidden="true" @click="$event.target.classList.contains('modal') ? close() : true">
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ config.title == null ? '&nbsp;' : config.title }}</h5>
                        <button type="button" class="close" @click="close()" v-html="ic('close')" />
                    </div>

                    <div class="modal-body text-center border">
                        <input type="text" v-model="initData" class="form-control" />
                    </div>
                    <div class="modal-footer pt-2 d-flex justify-content-between">
                        <button type="submit" class="btn btn-danger" 
                            @click="submit"
                            :disabled="isSubmit" 
                            v-html="isSubmit ? spin() : 'Delete'">
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade" :class="modal.open ? 'show' : ''" />
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";

export default {
    name: "FormDelete",
    props: {
        config: {
            default: {
                view: false,
                title: "Modal Title"
            }
        },
        initData: null,
        isSubmit: { default: false },
        dismiss: { default: true }
    },

    mixins: [helper],

    data() {
        return {
            backdrop: false,
            modal: {
                open: false,
                formNav: 0
            },
            request: true,
            form: {
                time: 0,
                loading: false,
                isSubmit: false,
                timeFinish: 0,
                interval: null,
            }
        };
    },

    methods: {
        close() {
            this.$emit("update:config", { view: false });
        },

        submit() {
            if (!this.initData) {
                this.toast('Anda belum memasukkan ID import')
            } else {
                this.$emit('update:isSubmit', true)
                this.$emit('submit', this.initData);
            }
        },
    },

    watch: {
        "config.view": function (view) {
            if (view) {
                this.$emit("update:isSubmit", false);

                this.backdrop = true;
                setTimeout(() => {
                    this.modal.open = view;
                }, 100);
            } else {
                this.modal.open = view;

                setTimeout(() => {
                    this.backdrop = view;
                }, 100);
            }
        },
    }
};
</script>
